import { render, staticRenderFns } from "./TrendChart.vue?vue&type=template&id=a9f7c742&"
import script from "./TrendChart.vue?vue&type=script&lang=js&"
export * from "./TrendChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9f7c742')) {
      api.createRecord('a9f7c742', component.options)
    } else {
      api.reload('a9f7c742', component.options)
    }
    module.hot.accept("./TrendChart.vue?vue&type=template&id=a9f7c742&", function () {
      api.rerender('a9f7c742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/trending-charts/TrendChart.vue"
export default component.exports